import React, { useState } from 'react';
import {AiOutlineCheck, AiOutlineClose, AiOutlineUser, AiOutlineReload} from 'react-icons/ai'
import {MdBlock, MdClose} from 'react-icons/md'
import config from '../../../enviroment/config.json'

import Button from '../../../components/Button';
import Modal from '../../../components/Modal';

function Members({c, members, description, onRevert, onBan, onRemove}) {
  
  const [userId, setUserId] = useState(null);
  const [revertModal, setRevertModal] = useState(false);
  const [banModal, setBanModal] = useState(false);
  const [removeModal, setRemoveModal] = useState(false);


  const revert = (id) => {
    setUserId(id);
    setRevertModal(true);
  }

  const ban = (id) => {
    setUserId(id);
    setBanModal(true);
  }
  
  const remove = (id) => {
    setUserId(id);
    setRemoveModal(true);
  }

  const closeModal = () => {
    setUserId(null);
    setRevertModal(false);
    setBanModal(false);
    setRemoveModal(false);
  }

  return (
  <div className={c.membersContainer}>
    {members?.length === 0 && <span style={{color: 'rgba(0,0,0,0.4)'}}>No member yet...</span>}

    {members?.map((m, index) => {
      return (
        <div key={"room-members-"+index}>
          <div className={c.memberCard}>
            <div className={c.memberL}>
              <div className={c.memberImage}>
                {m?.char ? 
                  <img src={`/chars/${m.char}.svg`} alt="User Character Image"></img>
                  :
                  <img src={"/chars/01.svg"} alt="User Character Image"></img>
                }
              </div>
              <h3>{m.name}</h3>
            </div>
            <div className={c.memberR}>
                <Button disabled={!m.voted} onClick={() => revert(m.id)} title={"Revert vote"} className={c.memberBtn + " " + c.btnReload}><AiOutlineReload></AiOutlineReload></Button>
                <Button onClick={() => ban(m.id)} title={"Ban"} className={c.memberBtn + " " + c.btnBlock}><MdBlock></MdBlock></Button>
                <Button onClick={() => remove(m.id)} title={"Remove from Room"} className={c.memberBtn + " " + c.btmClose}><MdClose></MdClose></Button>
            </div>
          </div>

          <Modal autoHeight title="Revert User Vote" visible={revertModal} onCancel={closeModal} onSubmit={() => {onRevert(userId); closeModal()}}>
              Do you really want to reset this user vote?
          </Modal>

          <Modal autoHeight title="Remove User" visible={removeModal} onCancel={closeModal} onSubmit={() => {onRemove(userId); closeModal()}}>
              Do you really want to remove this user from the room?
          </Modal>

          <Modal autoHeight title="Ban User" visible={banModal} onCancel={closeModal} onSubmit={() => {onBan(userId); closeModal()}}>
              Do you really want to ban this user?
          </Modal>
        </div>
      )
    })}

  </div>
  
  );
}

export default Members;